export const SET_CACHE = 'SET_CACHE'
export const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING'
export const SET_VIEWPORT = 'SET_VIEWPORT'
export const SET_TOUCH = 'SET_TOUCH'
export const SET_NETWORK_STATUS = 'SET_NETWORK_STATUS'
export const SET_PAGE = 'SET_PAGE'
export const SET_SUB_PAGE = 'SET_SUB_PAGE'
export const SET_HOME_CONTENT = 'SET_HOME_CONTENT'
export const SET_PROCESSINGS_EXCERPT = 'SET_PROCESSINGS_EXCERPT'
export const SET_INTERNALS_EXCERPT = 'SET_INTERNALS_EXCERPT'
export const SET_TEXT_GALLERY = 'SET_TEXT_GALLERY'
export const SET_PICTURE_GALLERY = 'SET_PICTURE_GALLERY'
